exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".button__3ObU::before {\n  margin-right: 8px; }\n", "", {"version":3,"sources":["/app/src/components/asset-library/src/components/asset-library/upload-button.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB,EACnB","file":"upload-button.scss","sourcesContent":[".button::before {\n  margin-right: 8px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"button": "button__3ObU"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"modules":true,"importLoaders":1,"localIdentName":"[local]__[hash:base64:4]"}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/asset-library/upload-button.scss
// module id = 959
// module chunks = 0